import { useLang } from "../../context/LanguageContext";

export const WhyMax = () => {
  const { t } = useLang();
  return (
    <section data-testid="why-section" className="py-24 lg:py-32 border-b border-[#0B1F3A]/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-12 gap-6 mb-14">
          <div className="col-span-12 lg:col-span-6">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-8 h-px bg-[#D4AF37]" />
              <span className="overline">{t.why.eyebrow}</span>
            </div>
            <h2 className="font-display text-3xl lg:text-4xl font-light text-[#0B1F3A] leading-tight">
              {t.why.title}
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 border-t border-l border-[#0B1F3A]/15">
          {t.why.items.map((it, i) => (
            <div
              key={it.t}
              data-testid={`why-${i}`}
              className="border-r border-b border-[#0B1F3A]/15 p-6 bg-white group hover:bg-[#F8F9FA] transition-colors min-h-[200px]"
            >
              <div className="text-[10px] tracking-widest text-[#D4AF37] font-semibold mb-4">
                {String(i + 1).padStart(2, "0")}
              </div>
              <h3 className="font-display text-base font-semibold text-[#0B1F3A] leading-snug">{it.t}</h3>
              <p className="mt-3 text-[13px] text-[#0B1F3A]/70 leading-relaxed">{it.d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
